(function () {

    'use strict';

    angular.module('Services').factory('ComplianceTable', ComplianceTable);
    ComplianceTable.$inject = [
        '$location',
        'ComplianceService',
        'TableLiteFactory',
        'toastr',
        'Units',
        '$rootScope'
    ];

    function ComplianceTable(
        $location,
        complianceService,
        TableLiteFactory,
        toastr,
        Units,
        $rootScope
    ) {
        return function () {
            const measureUnit = Units.getMeasureUnit($rootScope.GlobalProfile.office.measureUnit);
            const tableData = {
                tableName: 'ComplianceTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add new',
                        tooltip: 'Add new compliance rule',
                        onClick: function () {
                            $location.path('/compliance/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'Item ID',
                    viewName: 'itemId',
                    filterName: 'itemId',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Compliance Item Name',
                    viewName: 'itemName',
                    filterName: 'itemName',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Frequency',
                    viewName: 'frequency',
                    filterName: 'frequency',
                    width: '100px',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['ONCE', 'EVERY'],
                        onSelect: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Attachments',
                    viewName: 'attachments',
                    filterName: 'attachments',
                    width: '100px',
                }, {
                    label: 'Required',
                    viewName: 'requiredToProceed',
                    filterName: 'requiredToProceed',
                    width: '100px',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Yes', 'No'],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model === 'Yes';
                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Reminders',
                    viewName: 'remindersEnabled',
                    filterName: 'remindersEnabled',
                    width: '100px',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Enabled', 'Disabled'],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model === 'Enabled';
                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Triggers',
                    viewName: 'complianceTriggers',
                    filterName: 'complianceTriggers',
                    width: '200px'
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: complianceService.getAll,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                if (!data) {
                    return null;
                }

                angular.forEach(data.content, function (row, index) {
                    row.attachments = row.complianceAttachments.length;
                    row.complianceTriggers = {
                        type: 'multiLine',
                        list: row.complianceTriggers.length !== 0 ? row.complianceTriggers.map(item => item.triggerEvent) : ['N/A']
                    }
                    row.requiredToProceed = row.requiredToProceed ? 'Yes' : 'No';
                    row.remindersEnabled = row.remindersEnabled ? 'Enabled' : 'Disabled';
                    row.href = '/compliance/details/' + row.id;
                    tableData.data.push(row);
                });
                /*** END - Building of Data ***/
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/compliance/ComplianceTable.js